import angular from 'angular';

angular.module('cloudX').directive('cxColorPreview', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        color: '=',
        showLabel: '=',
        eClass: '@',
      },
      template:
        '<div class="color-preview" ng-class="eClass">' +
        '<span class="color-sprite"><span class="color" ng-style="color?{\'background-color\':color}:{}"></span></span>' +
        '<span class="lbl" ng-show="showLabel">{{color}}</span>' +
        '</div>',
    };
  },
]);
